import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import classnames from 'classnames';
import { get } from 'lodash';

import { Textarea, Input, Select } from 'shared/components/reduxFormComponents';
import { fieldTypes } from './fieldTypes';

import theme from './DynamicForm.scss';

const propTypes = {
  fields: PropTypes.array,
  handleSubmit: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

const defaultProps = {
  fields: [],
  className: undefined,
  disabled: false,
};

const RenderFields = ({ fields, disabled }) => fields.map(item => (
  <div className={ theme.field } key={ item.id }>
    <Choose>
      <When condition={ item.type === fieldTypes.FIELDSET && item.elements.length }>
        <RenderFields
          fields={ item.elements }
          disabled={ disabled }
        />
      </When>
      <When condition={ item.type === fieldTypes.TEXTAREA }>
        <Field
          component={ Textarea }
          id={ item.id }
          name={ item.path }
          label={ item.name }
          placeholder={ item.placeholder }
          rootClassName={ theme.textarea }
          maxLength={ get(item, 'validation.maxLength') }
          showLengthCounter={ true }
          disabled={ disabled }
        />
      </When>
      <When condition={ item.type === fieldTypes.INPUT }>
        <Field
          component={ Input }
          id={ item.id }
          name={ item.path }
          label={ item.name }
          placeholder={ item.placeholder }
          disabled={ disabled }
        />
      </When>
      <When condition={ item.type === fieldTypes.SELECT }>
        <Field
          component={ Select }
          id={ item.id }
          name={ item.path }
          label={ item.name }
          placeholder={ item.placeholder }
          items={ !item.elements.length ? null : item.elements }
          defaultValue={ item.value }
          disabled={ disabled }
        />
      </When>
    </Choose>
  </div>
));

RenderFields.propTypes = { fields: PropTypes.array.isRequired };

const DynamicForm = ({
  fields,
  handleSubmit,
  className,
  disabled,
}) => {
  return (
    <div className={ classnames(theme.root, className) }>
      <form onSubmit={ handleSubmit }>
        <RenderFields
          fields={ fields }
          disabled={ disabled }
        />
      </form>
    </div>
  );
};

DynamicForm.propTypes = propTypes;
DynamicForm.defaultProps = defaultProps;

export default reduxForm()(DynamicForm);
